import type { IconData } from '@stacksjs/iconify-core'

export const cutlery: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m3.303 16.738l8.066-8.065l.894.05c1.065.061 2.369-.485 3.415-1.53c1.636-1.637 1.934-3.723 1.06-4.597c-.873-.873-2.96-.575-4.596 1.06c-1.046 1.047-1.592 2.35-1.531 3.416l.05.894l-8.065 8.065a.5.5 0 0 0 .707.707m1.415 1.415a2.5 2.5 0 0 1-3.536-3.536l7.432-7.432c-.092-1.614.643-3.471 2.114-4.942c2.343-2.344 5.667-2.818 7.425-1.061c1.757 1.757 1.282 5.081-1.061 7.425c-1.471 1.47-3.329 2.205-4.943 2.114z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cutlery
